import Cookie from '@nuxt-common/util/app/utils/cookie/Cookie.js';
import { getError, getErrorMessage } from '#utils/ErrorHandler';
import { processErrorDetails } from '#utils/errorArrayDetails';
import { defineStore } from 'pinia';
import $http from '@vue-util/http';

const WISHLIST_ENDPOINT = '/xapi/wishlist/v1/lists';

export const useMoveItemStore = defineStore('moveItem', {
  state: () => ({
    moveItemError: null,
    moveItemErrorDetails: null,
    moveItemLoadingState: false,
    moveItemErrorStatus: false,
  }),
  actions: {
    async moveItem({ payload, newListGuid, headers }) {
      this.moveItemLoadingState = true;
      this.moveItemErrorStatus = false;
      this.moveItemError = null;
      try {
        const response = await $http.put(`${WISHLIST_ENDPOINT}/${newListGuid}/item/move`, payload, {
          headers,
        });
        const responseData = response.data || response;
        if (getError(responseData)) {
          const errorObj = getError(responseData);
          const errorDetails = processErrorDetails(errorObj);
          this.moveItemError = getErrorMessage(responseData, 'GENERIC');
          this.moveItemErrorDetails = errorDetails;
        }
      } catch (error) {
        if (error.response?.status === 401) {
          Cookie.set('SignedIn', '0');
          this.moveItemErrorStatus = true;
        }
        const data = error?.response?.data;
        const errorObj = getError(data);
        const errorDetails = processErrorDetails(errorObj);
        this.moveItemError = getErrorMessage(error, 'BAD_REQUEST');
        this.moveItemErrorDetails = errorDetails;
      } finally {
        this.moveItemLoadingState = false;
      }
    },
    setMoveItemError(error) {
      this.moveItemError = error;
    },
    setMoveItemErrorDetails(errorDetails) {
      this.moveItemErrorDetails = errorDetails;
    },
    setMoveItemLoadingState(loadValue) {
      this.moveItemLoadingState = loadValue;
    },
    setMoveItemErrorStatus(value) {
      this.moveItemErrorStatus = value;
    },
  },
});
